// @ts-ignore
import * as ramda from 'ramda';
// @ts-ignore
import ramdaCompose from 'ramda/es/compose';

/*
 * Takes an object whose values are objects including a `position` key,
 * and returns an array of those objects, sorted by that key.
 *
 * TODO: would like to use ramda.compose, but fails in client/email for some weird reason
 */
export const sortByPosition: <T>(arg1: {[key: string]: T}) => T[] = ramdaCompose(
    ramda.sortBy(ramda.prop('position')),
    ramda.values
);
